import safeMatch from '../utils/safe-match';

export const getAppName = safeMatch(1)(/^\/([a-z0-9-]+)/);
export const getOverlayName = safeMatch(1)(/^#\/([a-z0-9-]+)/);

const SIDEBAR_APPS = [
  'appointment',
  'wrapper/service',
  'wait-list',
  'appointment-v2',
  'appointment-v3',
];

const doesUrlMatchSomeApp = (url: string, appList: string[]): boolean =>
  appList.some((appName) => url.startsWith(`#/${appName}`));

export const isSidebarApp = (url: string): boolean =>
  doesUrlMatchSomeApp(url, SIDEBAR_APPS);

// Paths where the sidebar should be visually hidden — currently none.
// Example entry: 'appointment-v2'
export const isSidebarHidden = (url: string): boolean =>
  doesUrlMatchSomeApp(url, []);
